"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/form/style/css");

var _form = _interopRequireDefault(require("antd/es/form"));

var _react = _interopRequireWildcard(require("react"));

var _icons = require("@ant-design/icons");

require("./treeNode.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Item
} = _form.default;

class TreeQuestionNode extends _react.Component {
  constructor() {
    super(...arguments);
    this.styles = {
      deleteButton: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#f17878',
        borderColor: '#f17878',
        backgroundColor: '#FBDDDD',
        marginTop: '5px',
        marginRight: '5px',
        marginBottom: '5px'
      },
      addButton: {
        width: '200px',
        color: '#439AFF',
        borderColor: '#439AFF',
        backgroundColor: '#D0E6FF',
        marginTop: '5px',
        marginBottom: '5px'
      }
    };

    this.onTextChange = e => {
      const {
        question,
        updateQuestion
      } = this.props;
      updateQuestion({ ...question,
        text: e.target.value
      });
    };
  }

  render() {
    const {
      disabled,
      question,
      removeQuestion,
      addOption
    } = this.props;
    const {
      text,
      id
    } = question;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "tree-node-content"
    }, /*#__PURE__*/_react.default.createElement(Item, {
      className: "tree-node-title",
      key: `node-question-title-${id}`,
      name: `node-question-title-${id}`,
      rules: [{
        required: true,
        message: 'Tree questions must have text'
      }],
      initialValue: text,
      noStyle: true
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      spellCheck: true,
      disabled: disabled,
      placeholder: "Question text",
      bordered: false,
      onChange: this.onTextChange
    })), /*#__PURE__*/_react.default.createElement(_button.default, {
      key: `add-question-${id}`,
      className: "tree-node-add",
      color: "#439AFF",
      disabled: disabled,
      type: "dashed",
      onClick: () => addOption(id),
      style: this.styles.addButton
    }, /*#__PURE__*/_react.default.createElement(_icons.PlusOutlined, null), ' ', "Add option"), !disabled && /*#__PURE__*/_react.default.createElement(_button.default, {
      key: `delete-question-${id}`,
      className: "tree-node-delete",
      color: "#f17878",
      onClick: () => removeQuestion(id),
      style: this.styles.deleteButton
    }, /*#__PURE__*/_react.default.createElement(_icons.CloseOutlined, null)));
  }

}

var _default = TreeQuestionNode;
exports.default = _default;